import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';
import { avatarService } from '@/services/avatar';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useAvatarDefaultEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const { executeAction, excuteAndNotify, confirmAndRemove } = useCrudActions();

    const model = reactive({
        id: route.params.avatarId,
        type: null,
        name: '',
        gender: 0,
        isPublished: false,
        image: null,
        imageStatus: null,
        imageFile: null,
        canDelete: false
    });

    const validations = {
        imageFile: {},
        name: { required },
        type: { required },
        isPublished: { required }
    };

    const v$ = useVuelidate(validations, model);

    const actions = {
        fetch: executeAction({
            request: () => avatarService.default.get(model.id),
            onSuccess: ({ data }) => Object.assign(model, data),
            onError: () => router.push({ name: ROUTE_NAME_AVATAR.DEFAULT.INDEX })
        }),
        update: excuteAndNotify({
            validator: v$,
            request: () => avatarService.default.update(model.id, model.name, model.isPublished, model.imageFile),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.DEFAULT.INDEX })
        }),
        remove: confirmAndRemove({
            request: () => avatarService.default.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_AVATAR.DEFAULT.INDEX })
        })
    };

    return { model, v$, actions, typeList, genderList };
}

const genderList = [
    { label: 'Female', value: 0 },
    { label: 'Male', value: 1 }
];

const typeList = [
    { label: 'Bot', value: 1 },
    { label: 'Admin', value: 2 },
    { label: 'DefaultAvatar', value: 3 },
    { label: 'FakeAvatar', value: 4 }
];
